var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrenchCoat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n\t.st1{fill:none;stroke:#3B55E6;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.22,
    y: 79.33,
    className: "st0",
    width: 16.04,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.72,119.49H49.03c-0.55,0-1-0.45-1-1V67.5c0-0.55,0.45-1,1-1h40.89c0.52,0,0.96,5.4,1,5.92l5.8,45.99 c0.02,0.28-0.07,0.55-0.26,0.76S96,119.49,95.72,119.49z M50.03,117.49h44.61L88.99,68.5H50.03V117.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.03,116.17H23.26c-0.28,0-0.55-0.12-0.74-0.33c-0.19-0.21-0.28-0.49-0.25-0.77l6.8-47.66 c0.05-0.51,0.48-0.9,1-0.9h18.96c0.55,0,1,0.45,1,1v47.66C50.03,115.72,49.58,116.17,49.03,116.17z M24.36,114.17h23.66V68.5 H30.97L24.36,114.17z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89,68.52H31c-0.55,0-1-0.45-1-1v-5.01c0-0.55,0.45-1,1-1h58c0.55,0,1,0.45,1,1v5.01 C90,68.07,89.55,68.52,89,68.52z M32,66.52h56v-3.01H32V66.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.03,62.51c-0.55,0-1-0.45-1-1v-3.69c0-0.55,0.45-1,1-1s1,0.45,1,1v3.69 C50.03,62.06,49.58,62.51,49.03,62.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.98,10.31c-0.01-0.03-0.02-0.06-0.03-0.09c-0.01-0.05-0.03-0.09-0.05-0.14 c-0.03-0.06-0.07-0.12-0.11-0.17c-0.03-0.04-0.05-0.07-0.09-0.11c-0.06-0.06-0.12-0.1-0.19-0.14c-0.03-0.02-0.04-0.04-0.07-0.05 l-16-8c-0.32-0.16-0.7-0.14-1,0.06H36.55c-0.3-0.2-0.68-0.22-1-0.06l-16,8c-0.03,0.01-0.04,0.04-0.07,0.05 c-0.07,0.04-0.13,0.09-0.19,0.14c-0.03,0.03-0.06,0.07-0.09,0.11c-0.04,0.05-0.08,0.11-0.11,0.17c-0.02,0.04-0.04,0.09-0.05,0.14 c-0.01,0.03-0.03,0.06-0.03,0.09l-16,80c-0.06,0.29,0.02,0.6,0.21,0.83C3.42,91.37,3.7,91.51,4,91.51h16 c0.48,0,0.9-0.34,0.98-0.82L29,47.4v15.11c0,0.55,0.45,1,1,1h60c0.55,0,1-0.45,1-1V47.4l8.02,43.29c0.09,0.47,0.5,0.82,0.98,0.82 h16c0.3,0,0.58-0.13,0.77-0.37c0.19-0.23,0.27-0.54,0.21-0.83L100.98,10.31z M19.17,89.51H5.22L20.3,14.09l3.55,9.24l5.11,13.28 L19.17,89.51z M89.07,36.15c-0.04,0.1-0.06,0.21-0.06,0.32c0,0.01-0.01,0.02-0.01,0.04v25H31v-25c0-0.01-0.01-0.02-0.01-0.04 c0-0.11-0.02-0.22-0.06-0.32L21.26,11l14.67-7.33h48.14L98.74,11L89.07,36.15z M100.83,89.51l-9.8-52.9l5.11-13.28l3.55-9.24 l15.08,75.42H100.83z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.74,
    y: 79.33,
    className: "st0",
    width: 14.2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.03,58.63c-0.28,0-0.55-0.12-0.75-0.33c-0.3-0.34-0.34-0.84-0.09-1.22L83.51,1.35 c0.23-0.34,0.64-0.51,1.05-0.42c0.4,0.09,0.71,0.42,0.77,0.83l2.78,18.26c0.06,0.42-0.14,0.83-0.51,1.03l-12.21,6.69l1.62,14.73 c0.04,0.41-0.17,0.81-0.53,1L47.49,58.52C47.34,58.59,47.18,58.63,47.03,58.63z M83.74,4.6L50.03,54.94L74.95,42l-1.62-14.71 c-0.04-0.4,0.16-0.79,0.51-0.99l12.19-6.67L83.74,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.19,48.58l-9.79-5.36c-0.36-0.2-0.56-0.6-0.51-1.01l1.94-14.69l-12.06-6.95 c-0.36-0.21-0.56-0.62-0.49-1.04l3.17-18.19c0.07-0.41,0.38-0.73,0.79-0.81c0.4-0.08,0.82,0.1,1.04,0.44l23.56,36.9l-1.69,1.08 L36.98,4.22l-2.61,14.97l12.04,6.94c0.35,0.2,0.54,0.6,0.49,1l-1.94,14.67l9.19,5.03L53.19,48.58z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,106L76,106c-1.1,0-2-0.9-2-2V68h4v36C78,105.1,77.1,106,76,106z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrenchCoat);
export default __webpack_public_path__ + "static/media/trenchCoat.b5aa1e9a3d2ac728614a358b5bb86f0a.svg";
export { ForwardRef as ReactComponent };